var util = require('js/lib/util');
var moment = require('js/lib/moment');
var formatZip = require('js/lib/util').formatZip;
var editRouteTemplate = require('html/templates/editRoute')();
var t = require('js/lib/translate').t;

edit.$inject = ['$rootScope', 'load', 'modal'];

function edit($rootScope, load, modal) {

  this.openEditRoute = function($scope, event, route) {
    event.preventDefault();
    $scope.isSaving = false; // Reset

    $scope.move && $scope.move.close && $scope.move.close();

    $scope.timePattern = /^([01][0-9]|2[0-3]):?[0-5][0-9]$/;

    $scope.pickupLocations = $scope.routePlan.pickupLocations.map(function(pl) {
      // TODO Get right country
      return {
        id: pl.id,
        address: pl.address + ', ' + formatZip(pl.zip, pl.country) + ' ' + pl.city
      };
    });

    $scope.editRoute = {
      id: route.id,
      name: route.name,
      type: route.type,
      color: route.color || 0,
      overriddenStart:  util.toTime(route.overriddenStart),
      overriddenStartDayBefore: route.overriddenStart ? ! util.isSameDay(route.date, route.overriddenStart) : false,
      driverUsername: route.driverUsername || null,
      pickupLocationId: route.pickupLocationId || null,
      permitDriverComingSMS: route.permitDriverComingSMS,
      autoAssignedDriver: route.autoAssignedDriver
    };

    $scope.nameAndPhone = function(driver) {
      return driver.name + (driver.phone ? ' (' + driver.phone +')' : '');
    };

    $scope.reserveRoute = (route.type === 1);
    var titleKey = $scope.reserveRoute ? (route.id ? 'routeModalHeaderReserveEdit' : 'routeModalHeaderReserveNew') : (route.id ? 'routeModalHeaderEdit' : 'routeModalHeaderNew');

    if (! $scope.editRoute.pickupLocationId && $scope.pickupLocations.length === 1) {
      $scope.editRoute.pickupLocationId = $scope.pickupLocations[0].id;
    }

    modal.open({
      scope: $scope,
      klass: 'edit-route',
      title: t(titleKey),
      body: editRouteTemplate
    });

    $scope.routeColorChosen = function($index) {
      $scope.editRoute.color = $index;
    };
  };

  this.saveRoute = function($scope, route) {
    $scope.isSaving = true;
    if (route.fetchCustomers) {
      route.transferCustomersFromRouteId = route.fetchCustomersFromRoute.id;
    }

    // Overridden time/date
    var overriddenStart = util.toDateWithTime($scope.routePlan.date, route.overriddenStart);
    if (route.overriddenStartDayBefore) {
      overriddenStart = moment(overriddenStart).subtract(1, 'days');
    }
    route.overriddenStart = overriddenStart;

    delete route.overriddenStartDayBefore;  // Cleanup for API
    delete route.fetchCustomers;            // Cleanup for API
    delete route.fetchCustomersFromRoute;   // Cleanup for API

    if (route.id) {
      load.saveRoute(route).then(function() {
        $scope.closeModal();
      });
    } else {
      load.addRoute($scope.routePlan.id, route).then(function() {
        $scope.closeModal();
      });
    }
  };

  this.deleteEmptyRoute = function($scope, routeId) {
    load.deleteRoute(routeId);
    $scope.closeModal();
  };

}

module.exports = edit;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/editRoute.js
 ** module id = 196
 ** module chunks = 1
 **/